import { Theme, createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    authHeader: {
      border: 0,
      padding: theme.spacing(3, 5),
    },
    brokerage: {
      marginBottom: theme.spacing(3),
    },
    brokerageTitle: {
      paddingBottom: theme.spacing(1),
    },
    title: {
      paddingBottom: theme.spacing(1),
    },
  })
);
